import { extractErrorMessage } from './extractErrorMessage';

// A server refusal because the doctor's plan lacks a feature (owner, 1 Oct
// 2026): 403 { code: 'PLAN_FEATURE_MISSING', control, message: { en, fr } }.
// VIDEO_NOT_IN_PLAN and CHAT_NOT_IN_PLAN predate it and keep their codes, so
// the test is "the code contains PLAN" — the rule the other clients already
// follow: hide, do not retry, and say why.

// The code from any error-like shape: an axios error, a response body, or a
// rejected thunk payload that kept the body.
export const planRefusalCode = (source) => {
    const code = source?.response?.data?.code ?? source?.code ?? source?.data?.code ?? null;
    return typeof code === 'string' ? code : null;
};

export const isPlanRefusal = (source) => {
    const code = planRefusalCode(source);
    // A plan PICKER refusal (PLANS_PLATFORM_ONLY, DEFAULT_PLAN_REQUIRED, …)
    // is about package admin, not a missing feature — not one of these.
    return !!code && /NOT_IN_PLAN|PLAN_FEATURE_MISSING/.test(code);
};

// The server's sentence, in the reader's language; `fallback` only when the
// body carried none.
export const planRefusalMessage = (source, fallback = '', lang = 'en') =>
    extractErrorMessage(source, fallback, String(lang || 'en').slice(0, 2));
